<template>
  <div class="blog-single section">
    <div v-show="!page.loading">
      <!--<div class="page-headline">-->
        <!--<ul class="breadcrumbs">-->
          <!--<li>-->
            <!--<router-link :to="{name: 'home'}">Homepage</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link :to="{name: 'shop'}">L'blogs</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link :to="{name: 'shop'}">Art Deco շարժումը նորաձևության մեջ</router-link>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <div class="container is-boxed-fluid">
        <div class="post-heading">
          <h1>{{page.data.post.title}}</h1>
          <div class="subline">
            <strong v-if="page.data.post.subtitle">{{page.data.post.subtitle}}</strong>
            <strong>{{page.data.post.last_update}}</strong>
            <strong>Share <i class="icon-facebook"></i></strong>
          </div>
        </div>
        <div class="row">
          <div class="col-9 col-xs-12">
            <div class="content" v-html="page.data.post.content"></div>
            <div class="blog-navigation">
              <router-link v-if="page.data.previous" :to="$i18nRoute({name: 'blog-individual', params: {page: page.data.previous.slug[$i18n.locale]}})" class="prev-post">
                <i class="icon-left-arrow"></i> {{$t('previous_post')}}
              </router-link>
              <router-link v-if="page.data.next" :to="$i18nRoute({name: 'blog-individual', params: {page: page.data.next.slug[$i18n.locale]}})" class="next-post">
                {{$t('next_post')}}
                <i class="icon-right-arrow"></i>
              </router-link>
            </div>
          </div>
          <div class="col-3 col-xs-12">
            <div class="blog-widget">
              <subscribe-widget></subscribe-widget>
              <product-widget :products="page.data.products"></product-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container blog-loading" v-if="page.loading">
      <ul>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
        <li class="loading"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubscribeWidget from '@/components/blog/Subscribe.vue';
import ProductWidget from '@/components/blog/ProductWidget.vue';
export default {
  name: 'blog-individual',
  components: {
    SubscribeWidget,
    ProductWidget
  },
  data () {
    return {
      blog: {
        title: 'Art Deco շարժումը նորաձԵՎության մեջ',
        category: 'Art Deco',
        date: 'September4, 2019',
        image: '/img/blog-main.png'
      }
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.blog-single {
  padding-top: 130px;

  @include mq($ms){
    padding-top: 90px;
  }

  .blog-loading {
    .loading {
      height: 30px;
      animation: gradient 0.7s infinite;
      margin-bottom: 30px;

      &:nth-child(1) {
        height: 20px;
        width: 40%;
      }

      &:nth-child(2) {
        height: 70px;
        width: 80%;
      }

      &:nth-child(3) {
        height: 30px;
        width: 30%;
      }

      &:nth-child(4) {
        height: 400px;
        width: 100%;
      }

      &:nth-child(5) {
        height: 25px;
        width: 60%;
      }
      &:nth-child(6) {
        height: 25px;
        width: 65%;
      }
      &:nth-child(7) {
        height: 25px;
        width: 70%;
      }
      &:nth-child(8) {
        height: 25px;
        width: 40%;
      }
    }
  }

  .post-heading{
    margin-bottom: 30px;
    h1 {
      font-size: 36px;
      font-family: $font-bold;
      margin-top: 0;
      margin-bottom: 15px;

      @include mq($md) {
        font-size: 24px;
        margin-bottom: 15px;
      }
    }
    .subline {
      strong {
        font-family: $font-bold;
        margin-right: 30px;
      }
      span {
        color: #919191;
      }
    }
  }

  .main-image {
    margin-top: 30px;

    @include mq($ms){
      margin-left: -15px;
      margin-right: -15px;
    }

    img {
      width: 100%;
    }
  }
  .content {
    @include mq($ms){
      margin-top: 15px;
    }
    p {
      margin-top: 0;
    }
    strong {
      font-family: $font-bold;
    }
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: $font-bold;
      margin: 0;
      font-size: 18px;
    }
    img{
      width: 100%!important;
      margin-bottom: 15px;
      &+p{
        margin-top: 0;
      }
    }
  }
  .blog-navigation {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    a {
      font-family: $font-bold;
      border-bottom: 2px solid $main-color;
      padding-bottom: 10px;

      i {
        font-size: 16px;
        position: relative;
        transition: all 0.3s;
      }
      &.prev-post {
        i {
          margin-right: 10px;
          left: 0;
        }
        &:hover {
          i {
            left: -15px;
          }
        }
      }
      &.next-post {
        i {
          margin-left: 10px;
          right: 0;
        }
        &:hover {
          i {
            right: -15px;
          }
        }
      }
    }
  }
}
</style>
